<template>
  <footer id="sticky-footer" class="footer mt-auto py-3 border-top d-flex flex-wrap justify-content-center">
    <div class="text-left">
      <span class="text-muted text-start">Küchentime © {{ new Date().getFullYear() }}</span>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/Footer.vue